import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { getLeads, deleteLead, addLead, updateLead, getLeadDetail, updateLeadStatus, importLeadFromCSVFile, exportLead, assignTagToLead, getAllContactsConvert, getOpportunitiesConvert, getAllCampaign, addToCampaign, updateAccessibilityForLead, getAccessibilityForLead, changeOwner } from "./api";
import Select, { MultiValue } from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useNavigate } from "react-router-dom";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  optionschoose,
  optionsource,
  optionssymbol,
  optionSalutation,
  ratingOptions,
  genderOptions,
} from "../../../core/common/selectoption/selectoption";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { Pagination } from "antd";
import { leadsData } from "../../../core/data/json/leads";
import { Modal, Form, Button } from "react-bootstrap";
import { TableData } from "../../../core/data/interface";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { all_routes } from "../../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getTypePipeline } from "../pipeline/pipelineAPI";
import { getAllCompanies } from "../companies/companyAPI";
import { getOpportunities } from "../deals/dealsAPI";
import { getAllContacts } from "../contacts/contactAPI";
import { getContacts } from "../contacts/contactAPI";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { filter } from "../../../style/icon/fontawesome/js/v4-shims";
import { getTagList } from "../tags/tagAPI";
import { listLeadsOption, listOpportunitiesOption, listContactsOptionn, listAccountsOption, userList } from "./logcall_api";
import ResponseModal from "../../../core/modals/response_modal";

interface TagOption {
  value: number;
  label: string;
}
interface User {
  id: number;
  username: string;
  uuid: string;
  role: string;
}

interface Stage {
  id: number;
  name: string;
  order: number;
}

interface LeadListRequest {
  property?: string;
  direction?: "ASC" | "DESC";
  name?: string | null;
  company?: string | null;
  stageId?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  ownerAlias?: string[] | null;
  title?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email?: string | null;
  industry?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  source?: string | null;
  campaignId?: number | null;
  gender?: string | null;
  fromAge?: number | null;
  toAge?: number | null;
}


interface LeadData {
  id: number;
  salutation: string | null;
  firstName: string | null;
  lastName: string | null;
  gender: string | null;
  dob: string | null;
  email?: string | null;
  phone?: string | null;
  mobile?: string | null;
  rating?: number | null;
  owner?: string | null;
  title?: string | null;
  leadSource?: string | null;
  leadStatusId?: number | null;
  leadStatus?: string | null;
  language?: string | null;
  description?: string | null;
  company?: string | null;
  industry?: string | null;
  website?: string | null;
  noOfEmployees?: number | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  facebook?: string | null;
  skype?: string | null;
  linkedin?: string | null;
  twitter?: string | null;
  instagram?: string | null;
  whatsapp?: string | null;
  memberId: number | null;
  selectedPeople: number[];
  tags: Array<{
    tagId: number;
    name: string;
  }>;
  statusDto: {
    statusId: number;
    existedAccountId: number | null;
    existedContactId: number | null;
    existedOpportunityId: number | null;
    createContactRequestDTO: {
      salutation: string;
      firstName: string;
      lastName: string;
    };
    opportunityName: string;
    accountName: string;
    createOpportunity: boolean;
  };

  campaignHistory?: Array<{
    campaignId: string;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }>;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  public: boolean;
}

interface Lead {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
}

interface Campaign {
  id: number;
  name: string;
}

interface Account {
  accountId: number;
  accountName: string;
  type?: "new" | "existing";
}

interface Contact {
  contactId: number;
  contactName: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  type?: "new" | "existing";
}

interface Opportunity {
  id: number;
  name: string;
  type?: "new" | "existing";
}

interface Owner {
  id: number;
  name: string;
}

interface ConvertLeadForm {
  account: Account | null;
  contact: Contact | null;
  opportunity: Opportunity | null;
  owner: Owner | null;
  leadStatus?: string;
}
const formatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
const dobformatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


const Leads = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const [data, setData] = useState<Lead[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [show, setShow] = useState(false);
  const [show3, setShow3] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const handleClose = () => {
    setShow(false);
    setNewLead({
      id: 0,
      salutation: "",
      firstName: "",
      lastName: "",
      gender: "",
      dob: "",
      email: "",
      phone: "",
      mobile: "",
      rating: 0,
      owner: "",
      title: "",
      leadSource: "",
      leadStatus: "",
      leadStatusId: 0,
      language: "",
      description: "",
      company: "",
      industry: "",
      website: "",
      noOfEmployees: 0,
      street: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      facebook: "",
      skype: "",
      linkedin: "",
      twitter: "",
      instagram: "",
      whatsapp: "",
      memberId: 0,
      selectedPeople: [],
      tags: [],
      statusDto: {
        statusId: 0,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: "",
          firstName: "",
          lastName: "",
        },
        opportunityName: "",
        accountName: "",
        createOpportunity: false,
      },
      public: true,
    });
  };

  useEffect(() => {
    if (show) {
      setNewLead({
        id: 0,
        salutation: "",
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        email: "",
        phone: "",
        mobile: "",
        rating: 0,
        owner: "",
        title: "",
        leadSource: "",
        leadStatus: "",
        leadStatusId: 0,
        language: "",
        description: "",
        company: "",
        industry: "",
        website: "",
        noOfEmployees: 0,
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        facebook: "",
        skype: "",
        linkedin: "",
        twitter: "",
        instagram: "",
        whatsapp: "",
        memberId: 0,
        selectedPeople: [],
        tags: [],
        statusDto: {
          statusId: 0,
          existedAccountId: null,
          existedContactId: null,
          existedOpportunityId: null,
          createContactRequestDTO: {
            salutation: "",
            firstName: "",
            lastName: "",
          },
          opportunityName: "",
          accountName: "",
          createOpportunity: false,
        },
        public: true,
      });
    }
  }, [show]);

  const handleClose3 = () => {
    setShow3(false);
  };

  const handleShow2 = () => {
    setEditingLead(null);
    setNewLead({
      id: 0,
      salutation: "",
      firstName: "",
      lastName: "",
      gender: "",
      dob: "",
      email: "",
      phone: "",
      mobile: "",
      rating: 0,
      owner: "",
      title: "",
      leadSource: "",
      leadStatus: "",
      leadStatusId: 0,
      language: "",
      description: "",
      company: "",
      industry: "",
      website: "",
      noOfEmployees: 0,
      street: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      facebook: "",
      skype: "",
      linkedin: "",
      twitter: "",
      instagram: "",
      whatsapp: "",
      memberId: 0,
      selectedPeople: [],
      tags: [],
      statusDto: {
        statusId: 0,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: "",
          firstName: "",
          lastName: "",
        },
        opportunityName: "",
        accountName: "",
        createOpportunity: false,
      },
      public: true,
    });

    setShow(true);
  };


  const handleShow3 = () => setShow3(true);
  const [createdLeadUuid, setCreatedLeadUuid] = useState(null);
  const [editedLeadUuid, setEditedLeadUuid] = useState(null);
  const [editingLead, setEditingLead] = useState<LeadData | null>(null);
  const [leadToDelete, setLeadToDelete] = useState<{ id: number; name: string } | null>(null);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const handleCloseConvertModal = () => {
    setShowConvertModal(false);
    setSelectedAccount(null);
    setSelectedContact(null);
    setSelectedOpportunity(null);
  };
  const [initialStatus, setInitialStatus] = useState<number | null>(null);
  useEffect(() => {
    if (editingLead) {
      setInitialStatus(editingLead.statusDto?.statusId || null);
      setSelectedStatus(editingLead.statusDto?.statusId || "");
    }
  }, [editingLead]);
  const [selectedAccount, setSelectedAccount] = useState<{ value: string; label: string } | null>(null);
  const [selectedContact, setSelectedContact] = useState<{ value: string; label: string } | null>(null);
  const [selectedOpportunity, setSelectedOpportunity] = useState<{ value: string; label: string } | null>(null);
  const [selectedSalutation, setSelectedSalutation] = useState<string | null>(null);
  const [accountName, setAccountName] = useState("");
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [opportunityName, setOpportunityName] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [importMessage, setImportMessage] = useState<string>('');
  const [importErrors, setImportErrors] = useState<string[]>([]);
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState<{ value: number; label: string }[]>([]);
  const [accountOptions, setAccountOptions] = useState<{ value: string; label: string }[]>([]);
  const [contactOptions, setContactOptions] = useState<{ value: string; label: string }[]>([]);
  const [opportunityOptions, setOpportunityOptions] = useState<{ value: string; label: string }[]>([]);
  const [campaignOptions, setCampaignOptions] = useState<Campaign[]>([]);
  const [visibility, setVisibility] = useState("public");
  const [accountType, setAccountType] = useState<"new" | "existing">("existing");
  const [contactType, setContactType] = useState<"new" | "existing">("existing");
  const [opportunityType, setOpportunityType] = useState<"new" | "existing">("existing");
  const [tagModalOpen, setTagModalOpen] = useState(false);
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);
  const [selectedCampaign, setSelectedCampaign] = useState<number>();
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const [selectedOwnerUuid, setSelectedOwnerUuid] = useState<string>();
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const [convertForm, setConvertForm] = useState<ConvertLeadForm>({
    account: null,
    contact: null,
    opportunity: null,
    owner: null,
    leadStatus: "New",
  });
  const handleCloseImportModal = () => setShowImportModal(false);
  const handleCloseResultModal = () => setShowResultModal(false);  // Đóng modal kết quả
  const handleShowImportModal = () => {
    setShowImportModal(true);
  };  // Mở modal nhập CSV
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setCsvFile(file);
    }
  };
  const handleImportCsv = async () => {
    if (!csvFile) {
      setImportErrors(["Please select a CSV file before importing."]);
      setShowImportModal(false);
      setShowResultModal(true);
      return;
    }
    const validTypes = ['text/csv', 'application/vnd.ms-excel'];
    if (!validTypes.includes(csvFile.type) && !csvFile.name.endsWith('.csv')) {
      setImportErrors(["Invalid file format. Please upload a CSV file."]);
      setShowImportModal(false);
      setShowResultModal(true);
      return;
    }
    try {
      const response = await importLeadFromCSVFile(csvFile);
      console.log("Import successful:", response.data);

      if (response.status === 200) {
        const totalImported = response.data.data.totalImported ?? 0;
        const numberImportedLeads = response.data.data.numberImportedLeads ?? 0;
        const errors = response.data.data.errors || [];

        setImportMessage(
          `Total Imported lead: ${totalImported}\nNumber imported leads: ${numberImportedLeads}`
        );
        setImportErrors(errors);
        setShowImportModal(false);
        setShowResultModal(true);
        fetchLeads(0);
      }
    } catch (error: any) {
      console.error("Error importing CSV file:", error);
      setShowImportModal(false);
      setShowResultModal(true);
    } finally {
      setShowMessageModal(true);
    }
  };
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedRecordIds,
    onChange: (selectedKeys: any[]) => {
      setSelectedRecordIds(selectedKeys);
    },
  };

  const [showAssignTagModal, setShowAssignTagModal] = useState(false);
  const handleAssignTag = async () => {
    try {
      if (selectedRecordIds.length === 0 || selectedTagIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead and one tag." });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }

      const response = await assignTagToLead(selectedRecordIds, selectedTagIds, userId);
      console.log("Assign Tag Success:", response.data);
      setResponse({ status: "success", message: "Tags assigned successfully!" });
      setSelectedRecordIds([]);
      setSelectedTagIds([]);
      setShowAssignTagModal(false);
    } catch (error) {
      console.error("Error assigning tag:", error);
      setResponse({ status: "error", message: "Failed to assign tags. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };
  const [showChangeOwnerModal, setShowChangeOwnerModal] = useState(false);
  const handleChangeOwner = async () => {
    try {
      if (selectedRecordIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead" });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }
      const response = await changeOwner(selectedRecordIds, selectedOwnerUuid);
      console.log("Change Owner:", response.data);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Change Owner successfully!" });
        setSelectedRecordIds([]);
        setSelectedOwnerUuid("");
        setShowChangeOwnerModal(false);
      }
    } catch (error) {
      console.error("Error change owner", error);
      setResponse({ status: "error", message: "Failed to change owner. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const handleAddCampaign = async () => {
    try {
      if (selectedRecordIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead" });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }
      const response = await addToCampaign(selectedCampaign, selectedRecordIds);
      console.log("Add Lead To Campaign Success:", response.data);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Add Lead To Campaign successfully!" });
        setSelectedRecordIds([]);
        setSelectedCampaign(0);
        setShowCampaignModal(false);
      }
    } catch (error) {
      console.error("Error add lead to campaign", error);
      setResponse({ status: "error", message: "Failed to add to campaigns. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleDeleteClick = (id: number, name: string) => {
    setLeadToDelete({ id, name });
  };
  const handleConfirmDelete = () => {
    if (!leadToDelete) return;
    deleteLead(leadToDelete.id)
      .then(() => {
        setData(prev => prev.filter(lead => lead.leadId !== leadToDelete.id));
      })
      .catch(error => console.error("Error deleting lead:", error));
  };


  const handleEditClick = async (leadUuid: string) => {
    console.log("Lead UUID:", leadUuid);
    try {
      const response = await getLeadDetail(leadUuid);
      console.log("API response:", response.data.data);

      if (response.status === 200) {
        const leadData = response.data.data;
        setEditingLead({
          ...leadData,
          dob: dobformatDateForInput(leadData.dob),
          statusDto: {
            statusId: leadData.leadStatusId ?? 0,
            existedAccountId: null,
            existedContactId: null,
            existedOpportunityId: null,
            createContactRequestDTO: {
              salutation: leadData.salutation || "",
              firstName: leadData.firstName || "",
              lastName: leadData.lastName || "",
            },
            opportunityName: "",
            accountName: "",
            createOpportunity: false,
          },
        });
        setEditedLeadUuid(leadData.uuid);
        setShow3(true);
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };

  const handleConvertLead = async () => {
    const isEditing = editingLead?.id && editingLead?.id !== 0;

    if (isEditing) {
      console.log("Editing Lead:", editingLead);
    } else {
      console.log("Adding new Lead:", newLead);
    }

    const leadId = isEditing ? editingLead?.id : null;

    if (isEditing && !leadId) {
      console.error("Error: No valid Lead ID found!", editingLead);
      return;
    }

    try {
      const finalAccountName = accountType === "new" ? accountName || null : null;
      const finalOpportunityName = opportunityType === "new" ? opportunityName || null : null;

      const finalContactData =
        contactType === "new"
          ? {
            salutation: selectedSalutation || "",
            firstName: contactFirstName || "",
            lastName: contactLastName || "",
          }
          : null;

      const data = {
        statusId: isEditing ? editingLead?.statusDto?.statusId : newLead?.statusDto?.statusId,
        existedAccountId: accountType === "existing" ? Number(selectedAccount?.value) || null : null,
        existedContactId: contactType === "existing" ? Number(selectedContact?.value) || null : null,
        existedOpportunityId: opportunityType === "existing" ? Number(selectedOpportunity?.value) || null : null,
        createContactRequestDTO: finalContactData,
        opportunityName: finalOpportunityName,
        accountName: finalAccountName,
        createOpportunity: opportunityType === "new",
      };

      console.log("Dữ liệu gửi lên API:", data);

      if (isEditing) {
        const response = await updateLeadStatus(leadId, data);
        if (response?.status === 200) {
          setShowConvertModal(false);
          updateLeadData();
        } else {
          console.error("API Error:", response);
          setResponse({ status: "error", message: "Failed to convert lead. Please try again!" });
        }
      } else {
        const response = await addLead({
          ...newLead,
          statusDto: {
            statusId: newLead?.statusDto?.statusId || data.statusId,
            existedAccountId: data.existedAccountId,
            existedContactId: data.existedContactId,
            existedOpportunityId: data.existedOpportunityId,
            createContactRequestDTO: data.createContactRequestDTO,
            opportunityName: data.opportunityName,
            accountName: data.accountName,
            createOpportunity: data.createOpportunity,
          },
        });


        if (response?.status === 200) {
          console.log("Lead created successfully");
          const createdLead = response.data.data;
          setCreatedLeadUuid(createdLead.uuid);
          setOpenModal(true);
          setShowConvertModal(false);
        } else {
          console.error("API Error:", response);
          setResponse({ status: "error", message: "Failed to create lead. Please try again!" });
        }
      }
    } catch (error) {
      console.error("Error converting lead:", error);
      setResponse({ status: "error", message: "An unexpected error occurred. Please check the console for details." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const [filters, setFilters] = useState<LeadListRequest>({
    direction: "ASC",
    name: null,
    company: null,
    stageId: null,
    startDate: null,
    endDate: null,
    ownerAlias: null,
    title: null,
    phone: null,
    mobile: null,
    email: null,
    industry: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    source: null,
    campaignId: null,
    gender: null,
    fromAge: null,
    toAge: null,
  });


  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSortChange = async (property: string, direction: "ASC" | "DESC") => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      property,
      direction,
    }));

    try {
      const response = await getLeads({ ...filters, direction });
      setData(response.data.data.content);
    } catch (error) {
      console.error("Error fetching sorted leads:", error);
    }
  };

  const applyFilters = async () => {
    if (!validateLeadFilters()) {
      console.error("Validation failed:", errorsFilterForm);
      return;
    }
    try {
      const updatedFilters = { ...filters, pageNo: 0 };
      setFilters(updatedFilters);

      const response = await getLeads(updatedFilters);

      console.log("Response received:", response.data);
      setData(response.data.data.content || []);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageNo: newPage,
    }));
    fetchLeads(newPage);
  };

  const fetchLeads = async (page: number) => {
    try {
      const response = await getLeads({ ...filters, pageNo: page });
      console.log("API page:", page);
      console.log("API Response:", response.data.data);

      setData(response.data?.data.content || []);
      setPagination({
        totalPages: response.data?.data.totalPages || 1,
        totalElements: response.data?.data.totalElements || 0,
      });
    } catch (error) {
      console.error("Error fetching leads:", error);
      setData([]);
    }
  };

  const handleDateChange = (date: Date | null) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      createdDate: date ? date.toISOString() : "",
    }));
  };

  const [pagination, setPagination] = useState({
    totalPages: 1,
    totalElements: 0,
  });

  useEffect(() => {
    fetchLeads(0);
  }, []);

  const fetchContacts = async (accountId: number | null) => {
    if (!accountId) {
      setContactOptions([]);
      return;
    }

    try {
      const response = await getAllContactsConvert(accountId);
      const contacts = response.data.data.map((contact: Contact) => ({
        value: contact.contactId,
        label: contact.contactName,
      }));
      setContactOptions(contacts);
    } catch (error) {
      console.error("Error fetching Contacts:", error);
    }
  };


  const fetchOpportunities = async (accountId: number | null) => {
    if (!accountId) {
      setOpportunityOptions([]);
      return;
    }

    try {
      const response = await getOpportunitiesConvert(accountId);
      console.log("res:", response.data.data)
      const opportunities = response.data.data.map((oppor: Opportunity) => ({
        value: oppor.id,
        label: oppor.name,
      }));
      setOpportunityOptions(opportunities);
    } catch (error) {
      console.error("Error fetching Opportunities:", error);
    }
  };

  const fetchAccounts = async () => {
    try {
      const response = await getAllCompanies();
      const acc = response.data.data.map((acc: Account) => ({
        value: acc.accountId,
        label: acc.accountName,
      }));
      setAccountOptions(acc);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };
  const [users, setUsers] = useState<User[]>([]);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const fetchOwners = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userList(userTenantId);
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
      const owners = fetchedUsers.map((user: User) => ({
        value: user.uuid,
        label: user.username,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };
  useEffect(() => {
    fetchOwners();
  }, []);

  const fetchCampaigns = async () => {
    try {
      const response = await getAllCampaign();
      console.log("API Campaign:", response.data.data);
      setCampaignOptions(response.data.data.content);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  useEffect(() => {
    fetchAccounts();
    fetchOwners();
    fetchTags();
    fetchCampaigns();
  }, []);

  useEffect(() => {
    if (selectedAccount?.value && selectedAccount.value !== "new") {
      const accountId = Number(selectedAccount.value);
      fetchContacts(accountId);
      fetchOpportunities(accountId);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    } else {
      setContactOptions([]);
      setOpportunityOptions([]);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    }
  }, [selectedAccount]);



  type OptionType = { value: string; label: string };

  const handleOwnerChange = (selectedOptions: MultiValue<OptionType>) => {
    setSelectedOwners([...selectedOptions]);
    setFilters((prevFilters) => ({
      ...prevFilters,
      ownerAlias: selectedOptions.map((option: OptionType) => option.value),
    }));
  };

  const fetchStatusFilterOptions = async () => {
    try {
      const response = await getTypePipeline("LEAD");
      const options = response.data.data.map((item: Stage) => ({
        value: item.id,
        label: item.name,
      }));
      setStatusFilterOptions(options);
    } catch (error) {
      console.error("Error fetching status filter options:", error);
    }
  };

  useEffect(() => {
    fetchStatusFilterOptions();
  }, []);

  const [addStatusOptions, setAddStatusOptions] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    const fetchStatusOptions = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        if (response?.data) {
          console.log("Status option:", response.data.data);
          const options = response.data.data.map((stage: Stage) => ({
            value: stage.id,
            label: stage.name
          }));
          setAddStatusOptions(options);
        }
      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusOptions();
  }, []);



  const handleExportLeads = async () => {
    const exportData = {
      ...filters,
      fileName: "leads_export.csv"
    };
    try {
      const response = await exportLead(exportData);
      if (response && response.data) {
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = exportData.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };



  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const handleUpdateLead = async () => {
    if (!editingLead?.id) {
      console.error("Error: No valid ID found for update!", editingLead);
      return;
    }

    if (!validateEditForm()) {
      console.error("Validation failed:", errorsEditForm);
      return;
    }

    const previousStatusId = editingLead.leadStatusId;

    const newStatusId = editingLead.statusDto.statusId;

    const previousStatus = statusOptions.find((status) => status.id === previousStatusId);
    const selectedStatus = statusOptions.find((status) => status.id === newStatusId);

    console.log("Previous Status:", previousStatus);
    console.log("Selected Status:", selectedStatus);
    console.log("Max order from state:", maxorder);

    const isStatusChanged = previousStatusId !== newStatusId;

    if (isStatusChanged && selectedStatus?.order === maxorder && previousStatus?.order !== maxorder) {
      console.log("Opening Convert Modal...");
      setShowConvertModal(true);
    } else {
      console.log("Updating lead...");
      await updateLeadData();
    }
  };


  const updateLeadData = async () => {
    try {
      if (!editingLead) {
        console.error("No data to update");
        return;
      }
      const leadToEdit = {
        ...newLead,
        dob: newLead.dob
          ? new Date(newLead.dob + "T00:00:00").toISOString()
          : null,
      };
      console.log("Updating Lead with ID:", editingLead.id);
      const response = await updateLead(editingLead.id, leadToEdit);
      if (response.status === 200) {
        console.log("Lead updated successfully");
        setOpenEditSuccessModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };


  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };

  useEffect(() => {
    getLeads()
      .then((response) => {
        console.log("API Response:", response.data);

        if (response.data && Array.isArray(response.data.data.content)) {
          setData(response.data.data.content);
        } else {
          console.error("API response does not contain a valid leads list:", response.data);
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching leads:", error);
        setData([]);
      });
  }, []);


  const leadsWithKeys = data.map((lead) => ({
    ...lead,
    key: lead.leadId,
  }));

  const [newLead, setNewLead] = useState({
    id: 0,
    salutation: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    email: "",
    phone: "",
    mobile: "",
    rating: 0,
    owner: "",
    title: "",
    leadSource: "",
    leadStatus: "",
    leadStatusId: 0,
    language: "",
    description: "",
    company: "",
    industry: "",
    website: "",
    noOfEmployees: 0,
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    facebook: "",
    skype: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    whatsapp: "",
    memberId: 0,
    selectedPeople: [] as number[],
    tags: [] as { tagId?: number; name: string }[],
    statusDto: {
      statusId: 0,
      existedAccountId: null as number | null,
      existedContactId: null as number | null,
      existedOpportunityId: null as number | null,
      createContactRequestDTO: {
        salutation: "",
        firstName: "",
        lastName: "",
      },
      opportunityName: "",
      accountName: "",
      createOpportunity: false,
    },
    public: true,
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const [tempSelectedUsers, setTempSelectedUsers] = useState(newLead.selectedPeople || []);
  const handleChange = (selectedOptions: any) => {
    const selectedIds = selectedOptions.map((option: any) => option.value);
    setTempSelectedUsers(selectedIds);
    setNewLead(prev => ({ ...prev, selectedPeople: selectedIds }));
  };

  useEffect(() => {
    if (editingLead) {
      setNewLead({
        id: typeof editingLead.id === "number" ? editingLead.id : 0,
        leadStatus: editingLead.leadStatus || "",
        leadStatusId: editingLead.leadStatusId || 0,
        salutation: editingLead.salutation || "",
        firstName: editingLead.firstName || "",
        lastName: editingLead.lastName || "",
        gender: editingLead.gender || "",
        dob: editingLead.dob ? formatDate(editingLead.dob) : "",
        email: editingLead.email || "",
        phone: editingLead.phone || "",
        mobile: editingLead.mobile || "",
        rating: editingLead.rating ?? 0,
        owner: editingLead.owner || "",
        title: editingLead.title || "",
        leadSource: editingLead.leadSource || "",
        language: editingLead.language || "",
        description: editingLead.description || "",
        company: editingLead.company || "",
        industry: editingLead.industry || "",
        website: editingLead.website || "",
        noOfEmployees: editingLead.noOfEmployees ?? 0,
        street: editingLead.street || "",
        city: editingLead.city || "",
        state: editingLead.state || "",
        zip: editingLead.zip || "",
        country: editingLead.country || "",
        facebook: editingLead.facebook || "",
        skype: editingLead.skype || "",
        linkedin: editingLead.linkedin || "",
        twitter: editingLead.twitter || "",
        instagram: editingLead.instagram || "",
        whatsapp: editingLead.whatsapp || "",
        memberId: editingLead.memberId ?? 0,
        selectedPeople: editingLead.selectedPeople || null,
        tags: editingLead.tags
          ? editingLead.tags.map(tag => ({
            tagId: tag.tagId ?? 0,
            name: tag.name,
          }))
          : [],
        statusDto: {
          statusId: editingLead.statusDto?.statusId ?? 0,
          existedAccountId: editingLead.statusDto?.existedAccountId ?? null,
          existedContactId: editingLead.statusDto?.existedContactId ?? null,
          existedOpportunityId: editingLead.statusDto?.existedOpportunityId ?? null,
          createContactRequestDTO: {
            salutation: editingLead.statusDto?.createContactRequestDTO?.salutation || "",
            firstName: editingLead.statusDto?.createContactRequestDTO?.firstName || "",
            lastName: editingLead.statusDto?.createContactRequestDTO?.lastName || "",
          },
          opportunityName: editingLead.statusDto?.opportunityName || "",
          accountName: editingLead.statusDto?.accountName || "",
          createOpportunity: editingLead.statusDto?.createOpportunity ?? false,
        },
        public: editingLead.public ?? true,
      });
    }
  }, [editingLead]);


  const [selectedStatus, setSelectedStatus] = useState<number | "">("");

  useEffect(() => {
    console.log("Editing Lead from API:", editingLead);
  }, [editingLead]);

  useEffect(() => {
    if (editingLead) {
      console.log("Editing Lead:", editingLead);
      console.log("Status ID:", editingLead?.statusDto?.statusId, "Lead Stage ID:", editingLead?.leadStatusId);
      setSelectedStatus(editingLead?.statusDto?.statusId ?? editingLead?.leadStatusId ?? "");
    }
  }, [editingLead]);


  const [statusOptions, setStatusOptions] = useState<Stage[]>([]);

  const [maxorder, setMaxorder] = useState<number | null>(null);

  useEffect(() => {
    const fetchStatusEditOptions = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        const data = response.data.data || [];
        console.log("Pipeline data:", data);
        setStatusOptions(data);

        const validorders = data.map((item: Stage) => item.order).filter((id: number) => id !== undefined && id !== null);
        const maxOrder = validorders.length > 0 ? Math.max(...validorders) : 0;

        console.log("Max order:", maxOrder);
        setMaxorder(maxOrder);

      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusEditOptions();
  }, []);


  const handleStatusFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      stageId: selectedValue !== "" ? Number(selectedValue) : null,
    }));
  };

  const handleSelectFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value !== "" ? value : "",
    }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name === "noOfEmployees") {
      const numericValue = value.replace(/,/g, "");

      if (!/^\d*$/.test(numericValue)) return;

      const parsedValue = parseInt(numericValue || "0", 10);

      setNewLead(prevState => ({
        ...prevState,
        [name]: parsedValue,
      }));

      setEditingLead(prevState => {
        if (!prevState) return prevState;
        return {
          ...prevState,
          [name]: parsedValue,
        };
      });

      return;
    }

    setNewLead(prevState => ({
      ...prevState,
      [name]: value
    }));

    setEditingLead(prevState => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value
      };
    });
  };


  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setEditingLead(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        tags: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : [],
        id: prev.id ?? 0,
        memberId: prev.memberId ?? 0,
      };
    });
  };

  const handleSelectChange = (
    selectedOption: { value: string; label: string } | null,
    field: string
  ) => {
    setNewLead((prevState) => {
      if (!prevState) return prevState;

      return {
        ...prevState,
        [field]: selectedOption ? selectedOption.value : ""
      };
    });
    setEditingLead((prevState) => {
      if (!prevState) return prevState;

      return {
        ...prevState,
        [field]: selectedOption ? selectedOption.value : ""
      };
    });
  };

  const [errorsFilterForm, setErrorsFilterForm] = useState<Record<string, string>>({});
  const validateLeadFilters = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => {
      return /^0\d{9,10}$/.test(value);
    };

    const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const max50Fields = [
      "name", "company", "title", "phone", "mobile", "email",
      "industry", "street", "city", "state", "country"
    ];

    max50Fields.forEach((field) => {
      const value = (filters as any)[field];
      if (value) {
        if (["phone", "mobile"].includes(field)) {
          if (!isValidPhone(value)) {
            newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must start with 0 and contain 10–11 digits only.`;
          }
        } else if (field === "email") {
          if (!isValidEmail(value)) {
            newErrors.email = "Invalid email format.";
          } else {
            isTooLong(value, field);
          }
        } else {
          isTooLong(value, field);
        }
      }
    });

    if (filters.zip) {
      if (!onlyDigits(filters.zip) || filters.zip.length !== 6) {
        newErrors.zip = "ZIP must be 6 digits and contain digits only.";
      }
    }

    if (filters.fromAge && filters.toAge) {
      const from = Number(filters.fromAge);
      const to = Number(filters.toAge);
      if (!onlyDigits(filters.fromAge.toString()) || !onlyDigits(filters.toAge.toString())) {
        newErrors.age = "Age must be a valid number.";
      } else if (from > to) {
        newErrors.age = "From Age must not be greater than To Age.";
      }
    }

    if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      const end = new Date(filters.endDate);
      if (start > end) {
        newErrors.endDate = "End Date must be after Start Date.";
      }
    }

    setErrorsFilterForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [errorsAddForm, setErrorsAddForm] = useState<Record<string, string>>({});

  const validateAddForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => {
      return /^0\d{9,10}$/.test(value);
    };

    if (!newLead.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!newLead.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!newLead.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newLead.email)) newErrors.email = "Invalid email format";

    if (!newLead.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!isValidPhone(newLead.phone)) {
      newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";
    }

    if (newLead.mobile && !isValidPhone(newLead.mobile)) {
      newErrors.mobile = "Mobile must start with 0 and contain 10–11 digits only.";
    }

    if (!newLead.company.trim()) newErrors.company = "Company Name is required";
    if (!newLead.statusDto.statusId) newErrors.status = "Lead Status is required";
    if (!newLead.owner) newErrors.owner = "Owner is required";
    if (!newLead.dob.trim()) newErrors.dob = "Date of Birth is required";
    if (!newLead.gender.trim()) newErrors.gender = "Gender is required";

    const fieldsMax50 = [
      "firstName", "lastName", "company", "email", "website",
      "title", "facebook", "skype", "linkedin", "twitter",
      "whatsapp", "instagram", "street", "city", "state", "country"
    ];
    fieldsMax50.forEach((field) => {
      const value = (newLead as any)[field];
      if (value) isTooLong(value, field);
    });

    if (newLead.description && newLead.description.length > 256) {
      newErrors.description = "Description must not exceed 256 characters.";
    }

    if (newLead.zip) {
      if (!onlyDigits(newLead.zip) || newLead.zip.length !== 6) {
        newErrors.zip = "ZIP must be 6 digits and contain digits only.";
      }
    }

    if (newLead.noOfEmployees && (!/^\d+$/.test(newLead.noOfEmployees.toString()) || Number(newLead.noOfEmployees) >= 1000000)) {
      newErrors.noE = "Number of Employees must be a number less than 1,000,000.";
    }

    setErrorsAddForm(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const [errorsEditForm, setErrorsEditForm] = useState<Record<string, string>>({});

  const validateEditForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => {
      return /^0\d{9,10}$/.test(value);
    };

    if (editingLead) {
      if (!editingLead.firstName?.trim()) newErrors.firstName = "First Name is required";
      else isTooLong(editingLead.firstName, "firstName");

      if (!editingLead.lastName?.trim()) newErrors.lastName = "Last Name is required";
      else isTooLong(editingLead.lastName, "lastName");

      if (!editingLead.email?.trim()) newErrors.email = "Email is required";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editingLead.email)) newErrors.email = "Invalid email format";
      else isTooLong(editingLead.email, "email");

      if (!editingLead.phone?.trim()) newErrors.phone = "Phone is required";
      else if (!isValidPhone(editingLead.phone)) newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";

      if (editingLead.mobile && !isValidPhone(editingLead.mobile)) {
        newErrors.mobile = "Mobile must start with 0 and contain 10–11 digits only.";
      }

      if (!editingLead.company?.trim()) newErrors.company = "Company Name is required";
      else isTooLong(editingLead.company, "company");

      if (!editingLead.statusDto.statusId) newErrors.status = "Lead Status is required";

      if (!editingLead.owner) newErrors.owner = "Owner is required";

      if (!editingLead.dob?.trim()) newErrors.dob = "Date of Birth is required";

      if (!editingLead.gender?.trim()) newErrors.gender = "Gender is required";

      const fieldsMax50 = [
        "firstName", "lastName", "company", "email", "website",
        "title", "facebook", "skype", "linkedin", "twitter",
        "whatsapp", "instagram", "street", "city", "state", "country"
      ];
      fieldsMax50.forEach((field) => {
        const value = (editingLead as any)[field];
        if (value) isTooLong(value, field);
      });

      if (editingLead.description && editingLead.description.length > 256) {
        newErrors.description = "Description must not exceed 256 characters.";
      }

      if (editingLead.zip) {
        if (!onlyDigits(editingLead.zip) || editingLead.zip.length !== 6) {
          newErrors.zip = "ZIP must be 6 digits and contain digits only.";
        }
      }

      if (editingLead.noOfEmployees && (!/^\d+$/.test(editingLead.noOfEmployees.toString()) || Number(editingLead.noOfEmployees) >= 1000000)) {
        newErrors.noE = "Number of Employees must be a number less than 1,000,000.";
      }
    }

    setErrorsEditForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleCreateLead = async () => {
    if (!newLead) {
      console.error("Error: No valid lead data!", newLead);
      return;
    }

    if (!validateAddForm()) {
      console.error("Validation failed:", errorsAddForm);
      return;
    }

    const selectedStatus = statusOptions.find(
      (status: Stage) => status.id === newLead.statusDto.statusId
    );

    console.log("Selected Status:", selectedStatus);
    console.log("Max order from state:", maxorder);

    if (selectedStatus?.order === maxorder) {
      console.log("Opening Convert Modal...");
      setShowConvertModal(true);
    } else {
      console.log("Creating lead...");
      await createLeadData();
    }
  };

  const createLeadData = async () => {
    try {
      const leadToSend = {
        ...newLead,
        dob: newLead.dob
          ? new Date(newLead.dob + "T00:00:00").toISOString()
          : null,
      };

      const response = await addLead(leadToSend);

      if (response.status === 200) {
        console.log("Lead created successfully");
        const createdLead = response.data.data;
        setCreatedLeadUuid(createdLead.uuid);
        setOpenModal(true);
      }
    } catch (error) {
      console.error("Error creating lead:", error);
    }
  };

  const [showModalAccess, setShowModalAccess] = useState<boolean>(false);
  const [accessType, setAccessType] = useState<"public" | "private" | "isSelected">("public");
  const [selectedPeople, setSelectedPeople] = useState<any[]>([]);
  const [currentLeadId, setCurrentLeadId] = useState<number | null>(null);

  const handleCloseModalAccess = () => {
    setShowModalAccess(false);
    setCurrentLeadId(null);
    setSelectedPeople([]);
    setAccessType("public");
  };

  const handleSetAccessibility = async (leadId: number) => {
    try {
      const response = await getAccessibilityForLead(leadId);
      const accessibilityData = response.data.data;

      setCurrentLeadId(leadId);

      const isPublic = accessibilityData.public;
      const isPrivate = accessibilityData.private;
      const isSelected = accessibilityData.selected;
      const selected = accessibilityData.accessMembers || [];
      const selectedIds = selected.map((member: any) => member.memberId);

      if (isPublic && selectedIds.length === 0) {
        setAccessType("public");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isPrivate && selectedIds.length === 0) {
        setAccessType("private");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isSelected) {
        setAccessType("isSelected");
        setSelectedPeople(selectedIds);
        setTempSelectedUsers(selectedIds);
      }
      setShowModalAccess(true);
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Unauthorized" });
        setShowMessageModal(true);
      }
    }
  };



  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccessType(e.target.value as "public" | "private" | "isSelected");
  };

  const handleSaveAccessibility = async () => {
    if (!currentLeadId) return;

    let requestData;

    if (accessType === "public") {
      requestData = {
        public: true,
        selectedPeople: []
      };
    } else if (accessType === "private") {
      requestData = {
        public: false,
        selectedPeople: []
      };
    } else if (accessType === "isSelected") {
      requestData = {
        public: false,
        selectedPeople: tempSelectedUsers
      };
    }

    try {
      const response = await updateAccessibilityForLead(currentLeadId, requestData);
      if (response.status === 200) {
        setShowModalAccess(false);
        setResponse({ status: "success", message: "Change accessibility successfully!" });
      } else {
        setResponse({ status: "error", message: "Failed to save accessibility" });
      }
    } catch (err) {
      console.error("Error saving accessibility:", err);
    } finally {
      setShowMessageModal(true);
    }
  };


  const columns = [
    {
      title: "Lead Name",
      dataIndex: "leadName",
      render: (text: string, record: Lead) => (
        <Link to={`/leads-details/${record.leadUuid}`} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: Lead, b: Lead) => a.leadName.localeCompare(b.leadName),
    },
    {
      title: "Company Name",
      dataIndex: "company",
      sorter: (a: Lead, b: Lead) => a.company?.localeCompare(b.company || ""),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: Lead, b: Lead) => a.phone.localeCompare(b.phone),
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: Lead, b: Lead) => a.email.localeCompare(b.email),
    },
    {
      title: "Lead Status",
      dataIndex: "leadStatus",
      sorter: (a: Lead, b: Lead) => a.leadStatus?.localeCompare(b.leadStatus || ""),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      sorter: (a: Lead, b: Lead) => a.createdDate.localeCompare(b.createdDate),
      render: (createdDate: string) => {
        const formattedDate = new Date(createdDate);
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDateString = new Intl.DateTimeFormat('en-GB', options).format(formattedDate);
        return <span>{formattedDateString}</span>;
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: unknown, record: Lead) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{
              position: "absolute",
              inset: "0px auto auto 0px",
              margin: "0px",
              transform: "translate3d(-99.3333px, 35.3333px, 0px)",
            }}
            data-popper-placement="bottom-start"
          >
            {/* Edit Action */}
            <Link
              className="dropdown-item edit-popup"
              to="#"
              onClick={() => record.leadUuid && handleEditClick(record.leadUuid)}
            >
              <i className="ti ti-edit text-blue"></i> Edit
            </Link>

            {/* Delete Action */}
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_lead"
              onClick={() => record.leadId && handleDeleteClick(record.leadId, record.leadName)}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
            {/* Set Accessibility Action */}
            <Link
              className="dropdown-item"
              to="#"
              onClick={() =>
                record.leadId &&
                handleSetAccessibility(record.leadId)
              }
            >
              <i className="ti ti-lock-open text-warning"></i> Set Accessibility
            </Link>
          </div>
        </div>
      ),
    }
  ];

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Closed":
        return "bg-success";
      case "Connected":
        return "bg-warning";
      case "Lost":
        return "bg-danger";
      case "Not connected":
        return "bg-pending";
      default:
        return "bg-secondary";
    }
  };

  const handleDownloadSample = () => {
    const link = document.createElement('a');
    link.href = '/assets/sample.csv';
    link.download = 'sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Leads<span className="count-title">{data.length}</span>
                      </h4>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <Link to="#" className="btn btn-outline-primary" onClick={handleShowImportModal}>
                            <i className="ti ti-file-import me-2" />
                            Import from CSV
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-outline-danger ms-2"
                            onClick={handleExportLeads}
                          >
                            <i className="ti ti-file-export me-2" />
                            Export as CSV
                          </Link>


                          <Link to="#" className="btn btn-primary ms-2" onClick={handleShow2}>
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Lead
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="form-sorts dropdown me-2">
                          <Link
                            to="#"
                            className="btn btn-primary ms-2"
                            onClick={() => setShowChangeOwnerModal(true)}
                          >
                            <i className="ti ti-user" />
                            Change Owner
                          </Link>
                        </div>
                        <div className="form-sorts dropdown me-2">
                          <Link
                            to="#"

                            className="btn btn-primary ms-2"
                            onClick={() => setShowCampaignModal(true)}
                          >
                            <i className="ti ti-brand-campaignmonitor" />
                            Add to Campaign
                          </Link>
                        </div>
                        <div className="form-sorts dropdown me-2">
                          <Link to="#" className="btn btn-primary ms-2" onClick={() => setShowAssignTagModal(true)}>
                            <i className="ti ti-tags me-2" />
                            Assign Tag
                          </Link>
                        </div>
                        <div className="form-sorts dropdown me-2">
                          <Link
                            to="#"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-filter-share" />
                            Filter
                          </Link>
                          <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                            <div className="filter-set-view">
                              <div className="filter-set-head">
                                <h4>
                                  <i className="ti ti-filter-share" />
                                  Filter
                                </h4>
                              </div>
                              <div className="accordion" id="accordionExample">
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                      Lead
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse show" id="collapseTwo">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={filters?.name || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter lead name"
                                      />
                                      {errorsFilterForm.name && <small className="text-danger">{errorsFilterForm.name}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#GenderFilter">
                                      Gender
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="GenderFilter">
                                    <div className="filter-content-list">
                                      <select
                                        className="form-control"
                                        name="gender"
                                        value={filters.gender ?? ""}
                                        onChange={handleSelectFilterChange}
                                      >
                                        <option value="">Select gender</option>
                                        {genderOptions.map((gender) => (
                                          <option key={gender.value} value={gender.value}>
                                            {gender.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#AgeFilter">
                                      Age
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="AgeFilter">
                                    <div className="filter-content-list d-flex gap-2">
                                      <input
                                        type="number"
                                        min={0}
                                        className="form-control"
                                        placeholder="From age"
                                        name="fromAge"
                                        value={filters.fromAge ?? ""}
                                        onChange={(e) =>
                                          setFilters((prev) => ({
                                            ...prev,
                                            fromAge: e.target.value ? parseInt(e.target.value) : null,
                                          }))
                                        }
                                      />

                                      <input
                                        type="number"
                                        min={0}
                                        className="form-control"
                                        placeholder="To age"
                                        name="toAge"
                                        value={filters.toAge ?? ""}
                                        onChange={(e) =>
                                          setFilters((prev) => ({
                                            ...prev,
                                            toAge: e.target.value ? parseInt(e.target.value) : null,
                                          }))
                                        }
                                      />
                                      {errorsFilterForm.age && <small className="text-danger">{errorsFilterForm.age}</small>}
                                    </div>
                                  </div>
                                </div>

                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#company">
                                      Company Name
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="company">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="company"
                                        value={filters.company || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter company name"
                                      />
                                      {errorsFilterForm.company && <small className="text-danger">{errorsFilterForm.company}</small>}
                                    </div>
                                  </div>
                                </div>

                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#StatusFilter">
                                      Status
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="StatusFilter">
                                    <div className="filter-content-list">
                                      <select
                                        className="form-control"
                                        name="stageId"
                                        value={filters.stageId ?? ""}
                                        onChange={handleStatusFilterChange}
                                      >
                                        <option value="">Select Status</option>
                                        {statusFilterOptions.map((status) => (
                                          <option key={status.value} value={status.value}>
                                            {status.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#CreatedDateFilter">
                                      Created Date
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="CreatedDateFilter">
                                    <div className="filter-content-list d-flex gap-2">
                                      <DatePicker
                                        selected={filters.startDate ? new Date(filters.startDate) : null}
                                        onChange={(date: Date | null) =>
                                          setFilters((prev) => ({
                                            ...prev,
                                            startDate: date ? new Date(date.setHours(0, 0, 0, 0)).toISOString() : null,
                                          }))
                                        }
                                        className="form-control"
                                        placeholderText="Start date"
                                        dateFormat="yyyy-MM-dd"
                                      />

                                      <DatePicker
                                        selected={filters.endDate ? new Date(filters.endDate) : null}
                                        onChange={(date: Date | null) =>
                                          setFilters((prev) => ({
                                            ...prev,
                                            endDate: date ? new Date(date.setHours(23, 59, 59, 999)).toISOString() : null,
                                          }))
                                        }
                                        className="form-control"
                                        placeholderText="End date"
                                        dateFormat="yyyy-MM-dd"
                                      />
                                      {errorsFilterForm.endDate && <small className="text-danger">{errorsFilterForm.endDAte}</small>}
                                    </div>
                                  </div>
                                </div>

                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#owner">
                                      Lead Owner
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="owner">
                                    <div className="filter-content-list">
                                      <Select
                                        options={ownerOptions}
                                        isMulti
                                        value={selectedOwners}
                                        onChange={handleOwnerChange}
                                        placeholder="Search & Select Owners"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#title">
                                      Title
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="title">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        value={filters.title || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter title"
                                      />
                                      {errorsFilterForm.title && <small className="text-danger">{errorsFilterForm.title}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#phone">
                                      Phone
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="phone">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="phone"
                                        value={filters.phone || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter phone"
                                      />
                                      {errorsFilterForm.phone && <small className="text-danger">{errorsFilterForm.phone}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#mobile">
                                      Mobile
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="mobile">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="mobile"
                                        value={filters.mobile || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter mobile name"
                                      />
                                      {errorsFilterForm.mobile && <small className="text-danger">{errorsFilterForm.mobile}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#email">
                                      Email
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="email">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        value={filters.email || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter email name"
                                      />
                                      {errorsFilterForm.email && <small className="text-danger">{errorsFilterForm.email}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#industry">
                                      Industry
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="industry">
                                    <div className="filter-content-list">
                                      <select
                                        className="form-control"
                                        name="industry"
                                        value={filters.industry ?? ""}
                                        onChange={handleSelectFilterChange}
                                      >
                                        <option value="">Select industry</option>
                                        {optionindustry.map((industry) => (
                                          <option key={industry.value} value={industry.value}>
                                            {industry.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#street">
                                      Street
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="street">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="street"
                                        value={filters.street || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter street"
                                      />
                                      {errorsFilterForm.street && <small className="text-danger">{errorsFilterForm.street}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#city">
                                      City
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="city">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="city"
                                        value={filters.city || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter city"
                                      />
                                      {errorsFilterForm.city && <small className="text-danger">{errorsFilterForm.city}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#state">
                                      State
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="state">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="state"
                                        value={filters.state || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter state"
                                      />
                                      {errorsFilterForm.state && <small className="text-danger">{errorsFilterForm.state}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#country">
                                      Country
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="country">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="country"
                                        value={filters.country || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter country"
                                      />
                                      {errorsFilterForm.country && <small className="text-danger">{errorsFilterForm.country}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#zip">
                                      Zip
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="zip">
                                    <div className="filter-content-list">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="zip"
                                        value={filters.zip || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Enter zip"
                                      />
                                      {errorsFilterForm.zip && <small className="text-danger">{errorsFilterForm.zip}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#source">
                                      Source
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="source">
                                    <div className="filter-content-list">
                                      <select
                                        className="form-control"
                                        name="source"
                                        value={filters.source ?? ""}
                                        onChange={handleSelectFilterChange}
                                      >
                                        <option value="">Select source</option>
                                        {optionsource.map((source) => (
                                          <option key={source.value} value={source.value}>
                                            {source.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#campaign">
                                      Campaign
                                    </Link>
                                  </div>
                                  <div className="filter-set-contents accordion-collapse collapse" id="campaign">
                                    <div className="filter-content-list">
                                      <select
                                        className="form-control"
                                        name="campaignId"
                                        value={filters.campaignId ?? ""}
                                        onChange={handleSelectFilterChange}
                                      >
                                        <option value="">Select campaign</option>
                                        {campaignOptions.map((campaign) => (
                                          <option key={campaign.id} value={campaign.id}>
                                            {campaign.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-6">
                                    <Link
                                      to="#"
                                      className="btn btn-light"
                                      onClick={() => {
                                        setFilters((prevFilters) => ({
                                          ...prevFilters,
                                          direction: "ASC",
                                          name: null,
                                          company: null,
                                          stageId: null,
                                          startDate: null,
                                          endDate: null,
                                          ownerAlias: null,
                                          title: null,
                                          phone: null,
                                          mobile: null,
                                          email: null,
                                          industry: null,
                                          street: null,
                                          city: null,
                                          state: null,
                                          zip: null,
                                          country: null,
                                          source: null,
                                          campaignId: null,
                                          gender: null,
                                          fromAge: null,
                                          toAge: null,
                                        }));
                                        setSelectedOwners([]);
                                      }}>
                                      Reset
                                    </Link>
                                  </div>
                                  <div className="col-6">
                                    <Link to="#" className="btn btn-primary" onClick={applyFilters}>
                                      Apply Filter
                                    </Link>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="view-icons">
                          <Link to={route.leads} className="active">
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link to={route.leadsKanban}>
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Filter */}
                    {/* Paging */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={leadsWithKeys} columns={columns} rowSelection={rowSelection} />
                    </div>
                    {/* /Paging */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Lead */}
        <Offcanvas show={show} onHide={handleClose} placement="end" >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Add New Lead</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="accordion" id="main_accordion">
                {/* Basic Info */}
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#basic"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                      </span>
                      Basic Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse show"
                    id="basic"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Salutation</label>
                            <Select
                              className="select2"
                              options={optionSalutation}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "salutation")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              First Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="firstName"
                              value={newLead.firstName}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.firstName && <small className="text-danger">{errorsAddForm.firstName}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="lastName"
                              value={newLead.lastName}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.lastName && <small className="text-danger">{errorsAddForm.lastName}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Gender<span className="text-danger">*</span>
                            </label>
                            <div className="icon-form-end">
                              <span className="form-icon">
                                <i className="ti ti-star" />
                              </span>
                              <Select
                                className="select2"
                                options={genderOptions}
                                classNamePrefix="react-select"
                                onChange={(selectedOption) =>
                                  handleSelectChange(selectedOption, "gender")
                                }
                              />
                              {errorsAddForm.gender && <small className="text-danger">{errorsAddForm.gender}</small>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Date of Birth <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="dob"
                              value={newLead.dob}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.dob && <small className="text-danger">{errorsAddForm.dob}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Company Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="company"
                              value={newLead.company}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.company && <small className="text-danger">{errorsAddForm.company}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <label className="col-form-label">
                                Email <span className="text-danger">*</span>
                              </label>
                            </div>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={newLead.email}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.email && <small className="text-danger">{errorsAddForm.email}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              value={newLead.phone}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.phone && <small className="text-danger">{errorsAddForm.phone}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Mobile</label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobile"
                              value={newLead.mobile || ""}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.mobile && <small className="text-danger">{errorsAddForm.mobile}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Website
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="website"
                              value={newLead.website}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.website && <small className="text-danger">{errorsAddForm.website}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Ratings</label>
                            <div className="icon-form-end">
                              <span className="form-icon">
                                <i className="ti ti-star" />
                              </span>
                              <Select
                                className="select2"
                                options={ratingOptions}
                                classNamePrefix="react-select"
                                onChange={(selectedOption) =>
                                  handleSelectChange(selectedOption, "rating")
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Owner</label><span className="text-danger">*</span>
                            <Select
                              className="select2"
                              options={ownerOptions}
                              classNamePrefix="react-select"
                              value={selectedOwners ? selectedOwners[0] : null}
                              onChange={(selectedOption) => {
                                const newSelected = selectedOption ? [selectedOption] : [];
                                setSelectedOwners(newSelected);
                                setNewLead(prev => ({
                                  ...prev,
                                  owner: selectedOption ? selectedOption.value : ''
                                }));
                              }}
                              placeholder="Select Owner"
                            />
                            {errorsAddForm.owner && <small className="text-danger">{errorsAddForm.owner}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Status</label><span className="text-danger">*</span>
                            <Select
                              className="select2"
                              options={addStatusOptions}
                              classNamePrefix="react-select"
                              value={addStatusOptions.find(option => option.value === newLead.statusDto.statusId) || null}
                              onChange={(selectedOption) => {
                                console.log("Selected Status:", selectedOption);
                                setNewLead((prevLead) => ({
                                  ...prevLead,
                                  statusDto: {
                                    ...prevLead.statusDto,
                                    statusId: selectedOption?.value ?? 0,
                                  },
                                }));
                              }}
                            />
                            {errorsAddForm.status && <small className="text-danger">{errorsAddForm.status}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Tags
                            </label>
                            <Select
                              isMulti
                              options={allTags.map(tag => ({
                                value: tag.id,
                                label: tag.name
                              }))}
                              placeholder="Select tags"
                              classNamePrefix="react-select"
                              value={newLead.tags.map(tag => ({
                                value: tag.tagId,
                                label: tag.name
                              }))}
                              onChange={(selectedOptions) => {
                                console.log("Selected Tags:", selectedOptions);
                                setNewLead(prev => ({
                                  ...prev,
                                  tags: selectedOptions ? selectedOptions.map(option => ({
                                    tagId: option.value,
                                    name: option.label
                                  })) : []
                                }));
                              }}
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  minHeight: "50px",
                                  maxHeight: "auto",
                                  overflowY: "auto",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              value={newLead.title}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.title && <small className="text-danger">{errorsAddForm.title}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Source</label>
                            <Select
                              className="select2"
                              options={optionsource}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "leadSource")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Industry</label>
                            <Select
                              className="select2"
                              options={optionindustry}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "industry")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">No. of Employees</label>
                            <input
                              type="text"
                              className="form-control"
                              name="noOfEmployees"
                              value={
                                newLead.noOfEmployees !== null && newLead.noOfEmployees !== undefined
                                  ? newLead.noOfEmployees.toLocaleString("en-US")
                                  : ""
                              }
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.noE && <small className="text-danger">{errorsAddForm.noE}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Language</label>
                            <Select
                              className="select"
                              options={languageOptions}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "language")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-0">
                            <label className="col-form-label">Description</label>
                            <textarea
                              className="form-control"
                              rows={5}
                              name="description"
                              value={newLead.description}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.description && <small className="text-danger">{errorsAddForm.description}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Basic Info */}

                {/* Address Info */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#address"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-map-pin-cog fs-20" />
                      </span>
                      Address Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="address"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Street Address
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="street"
                              value={newLead.street}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.street && <small className="text-danger">{errorsAddForm.street}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">City</label>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={newLead.city}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.city && <small className="text-danger">{errorsAddForm.city}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              State / Province
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="state"
                              value={newLead.state}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.state && <small className="text-danger">{errorsAddForm.state}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Country
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="country"
                              value={newLead.country}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.country && <small className="text-danger">{errorsAddForm.country}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Zipcode</label>
                            <input
                              type="text"
                              className="form-control"
                              name="zip"
                              value={newLead.zip}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.zip && <small className="text-danger">{errorsAddForm.zip}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address Info */}

                {/* Social Profile */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#social"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-social fs-20" />
                      </span>
                      Social Profile
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="social"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Facebook</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook"
                              value={newLead.facebook}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.facebook && <small className="text-danger">{errorsAddForm.facebook}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Skype</label>
                            <input
                              type="text"
                              className="form-control"
                              name="skype"
                              value={newLead.skype}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.skype && <small className="text-danger">{errorsAddForm.skype}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Linkedin</label>
                            <input
                              type="text"
                              className="form-control"
                              name="linkedin"
                              value={newLead.linkedin}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.linkedin && <small className="text-danger">{errorsAddForm.linkedin}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Twitter</label>
                            <input
                              type="text"
                              className="form-control"
                              name="twitter"
                              value={newLead.twitter}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.twitter && <small className="text-danger">{errorsAddForm.twitter}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 mb-md-0">
                            <label className="col-form-label">Whatsapp</label>
                            <input
                              type="text"
                              className="form-control"
                              name="whatsapp"
                              value={newLead.whatsapp}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.whatsapp && <small className="text-danger">{errorsAddForm.whatsapp}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Instagram</label>
                            <input
                              type="text"
                              className="form-control"
                              name="instagram"
                              value={newLead.instagram}
                              onChange={handleInputChange}
                            />
                            {errorsAddForm.instagram && <small className="text-danger">{errorsAddForm.instagram}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Social Profile */}

                {/* Access */}
                {/* <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#access-info"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-accessible fs-20" />
                      </span>
                      Access
                    </Link>
                  </div>
                  <div className="accordion-collapse collapse" id="access-info" data-bs-parent="#main_accordion">
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Visibility</label>
                            <div className="d-flex flex-wrap">

                              {/* Public */}
                {/* <div className="me-2">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="public"
                                  name="visibility"
                                  value="public"
                                  checked={visibility === "public"}
                                  onChange={() => {
                                    setVisibility("public");
                                    setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                                  }}
                                />
                                <label htmlFor="public">Public</label>
                              </div> */}

                {/* Private */}
                {/* <div className="me-2">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="private"
                                  name="visibility"
                                  value="private"
                                  checked={visibility === "private"}
                                  onChange={() => {
                                    setVisibility("private");
                                    setNewLead(prev => ({ ...prev, public: false, selectedPeople: [] }));
                                  }}
                                />
                                <label htmlFor="private">Private</label>
                              </div> */}

                {/* Select user */}
                {/* <div className="me-2">
                                <input
                                  type="radio"
                                  className="status-radio"
                                  id="user"
                                  name="visibility"
                                  value="user"
                                  checked={visibility === "user"}
                                  onChange={() => {
                                    setVisibility("user");
                                    setTempSelectedUsers(newLead.selectedPeople);
                                    setNewLead(prev => ({ ...prev, public: false }));
                                  }}
                                />
                                <label htmlFor="user">Select user</label>
                              </div>

                            </div>
                          </div>

                          {visibility === "user" && (
                            <div className="mb-3">
                              <label className="col-form-label">Select Users</label>
                              <Select
                                isMulti
                                name="users"
                                options={users.map(user => ({
                                  value: user.id,
                                  label: `${user.username} - ${user.role}`
                                }))}
                                value={users.filter(user => tempSelectedUsers.includes(user.id)).map(user => ({
                                  value: user.id,
                                  label: `${user.username} - ${user.role}`
                                }))}
                                onChange={handleChange}
                                isSearchable={true}
                              />
                            </div>
                          )}

                          {visibility === "user" && tempSelectedUsers.length > 0 && (
                            <div className="mt-2 p-2 border rounded bg-light">
                              <strong>Selected Users:</strong>
                              <ul className="mb-0 ps-3">
                                {tempSelectedUsers.map(userId => {
                                  const user = users.find(u => u.id === userId);
                                  return user ? <li key={user.id}>{user.username} - {user.role}</li> : null;
                                })}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* /Access */}

              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateLead}
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        {/* /Add Lead */}
        {/* Edit Lead */}
        <Offcanvas show={show3} onHide={handleClose3} placement="end">
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Update Lead</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose3}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="accordion" id="main_accordion">
                {/* Basic Info */}
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#basic"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                      </span>
                      Basic Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse show"
                    id="basic"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Salutation</label>
                            <Select
                              className="select2"
                              options={optionSalutation}
                              classNamePrefix="react-select"
                              value={optionSalutation.find(
                                (option) => option.value === editingLead?.salutation
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "salutation")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              First Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="firstName"
                              value={editingLead?.firstName || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.firstName && <small className="text-danger">{errorsEditForm.firstName}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="lastName"
                              value={editingLead?.lastName || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.lastName && <small className="text-danger">{errorsEditForm.lastName}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Gender
                              <span className="text-danger">*</span>
                            </label>
                            <div className="icon-form-end">
                              <span className="form-icon">
                                <i className="ti ti-star" />
                              </span>
                              <Select
                                className="select2"
                                options={genderOptions}
                                classNamePrefix="react-select"
                                value={genderOptions.find(
                                  (option) => (option.value) === editingLead?.gender
                                )}
                                onChange={(selectedOption) =>
                                  handleSelectChange(selectedOption, "gender")
                                }
                              />
                              {errorsEditForm.gender && <small className="text-danger">{errorsEditForm.gender}</small>}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Date of Birth <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="dob"
                              value={editingLead?.dob || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.dob && <small className="text-danger">{errorsEditForm.dob}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Company Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="company"
                              value={editingLead?.company || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.company && <small className="text-danger">{errorsEditForm.company}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Email <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={editingLead?.email || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.email && <small className="text-danger">{errorsEditForm.email}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              value={editingLead?.phone || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.phone && <small className="text-danger">{errorsEditForm.phone}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Mobile</label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobile"
                              value={editingLead?.mobile || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.mobile && <small className="text-danger">{errorsEditForm.mobile}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Website
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="website"
                              value={editingLead?.website || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.website && <small className="text-danger">{errorsEditForm.website}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Ratings</label>
                            <div className="icon-form-end">
                              <span className="form-icon">
                                <i className="ti ti-star" />
                              </span>
                              <Select
                                className="select2"
                                options={ratingOptions}
                                classNamePrefix="react-select"
                                value={ratingOptions.find(
                                  (option) => Number(option.value) === editingLead?.rating
                                )}
                                onChange={(selectedOption) =>
                                  handleSelectChange(selectedOption, "rating")
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Owner</label><span className="text-danger">*</span>
                            <Select
                              className="select2"
                              options={ownerOptions}
                              classNamePrefix="react-select"
                              value={selectedOwners}
                              onChange={(selectedOption) => {
                                setSelectedOwners(selectedOption ? [selectedOption] : []);

                                setEditingLead((prevState) => {
                                  if (!prevState) return null;
                                  return {
                                    ...prevState,
                                    owner: selectedOption?.value || "",
                                    id: prevState.id ?? 0,
                                  };
                                });
                              }}
                              placeholder="Select Owner"
                            />
                            {errorsEditForm.owner && <small className="text-danger">{errorsEditForm.owner}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Status</label><span className="text-danger">*</span>
                            <select
                              className="form-select"
                              value={selectedStatus}
                              onChange={(e) => {
                                const newStatusId = Number(e.target.value);
                                setSelectedStatus(newStatusId);

                                setEditingLead((prevLead) =>
                                  prevLead
                                    ? {
                                      ...prevLead,
                                      statusDto: {
                                        ...prevLead.statusDto,
                                        statusId: newStatusId,
                                      },
                                      leadStageId: newStatusId,
                                    }
                                    : null
                                );
                              }}
                            >
                              <option value="">Select Status</option>
                              {statusOptions.map((status) => (
                                <option key={status.id} value={status.id}>
                                  {status.name}
                                </option>
                              ))}
                            </select>
                            {errorsEditForm.status && <small className="text-danger">{errorsEditForm.status}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Tags</label>
                            <Select
                              isMulti
                              options={allTags.map(tag => ({
                                value: tag.id,
                                label: tag.name
                              }))}
                              value={editingLead?.tags?.map(tag => ({
                                value: tag.tagId,
                                label: tag.name
                              })) || []}
                              onChange={handleTagChange}
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  minHeight: "50px",
                                  maxHeight: "auto",
                                  overflowY: "auto",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />

                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              value={editingLead?.title || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.title && <small className="text-danger">{errorsEditForm.title}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Source</label>
                            <Select
                              className="select2"
                              options={optionsource}
                              classNamePrefix="react-select"
                              value={optionsource.find(
                                (option) => option.value === editingLead?.leadSource
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "leadSource")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Industry</label>
                            <Select
                              className="select2"
                              options={optionindustry}
                              classNamePrefix="react-select"
                              value={optionindustry.find(
                                (option) => option.value === editingLead?.industry
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "industry")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">No. of Employees</label>
                            <input
                              type="text"
                              className="form-control"
                              name="noOfEmployees"
                              value={editingLead?.noOfEmployees || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.noE && <small className="text-danger">{errorsEditForm.noE}</small>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Language</label>
                            <Select
                              className="select"
                              options={languageOptions}
                              value={languageOptions.find(
                                (option) => option.value === editingLead?.language
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "language")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-0">
                            <label className="col-form-label">Description</label>
                            <textarea
                              className="form-control"
                              rows={5}
                              name="description"
                              value={editingLead?.description || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.description && <small className="text-danger">{errorsEditForm.description}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Basic Info */}

                {/* Address Info */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#address"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-map-pin-cog fs-20" />
                      </span>
                      Address Info
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="address"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">Street Address</label>
                            <input
                              type="text"
                              className="form-control"
                              name="street"
                              value={editingLead?.street || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.street && <small className="text-danger">{errorsEditForm.street}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">City</label>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={editingLead?.city || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.city && <small className="text-danger">{errorsEditForm.city}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">State / Province</label>
                            <input
                              type="text"
                              className="form-control"
                              name="state"
                              value={editingLead?.state || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.state && <small className="text-danger">{errorsEditForm.state}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Country</label>
                            <input
                              type="text"
                              className="form-control"
                              name="country"
                              value={editingLead?.country || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.country && <small className="text-danger">{errorsEditForm.country}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Zipcode</label>
                            <input
                              type="text"
                              className="form-control"
                              name="zip"
                              value={editingLead?.zip || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.zip && <small className="text-danger">{errorsEditForm.zip}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address Info */}

                {/* Social Profile */}
                <div className="accordion-item border-top rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#social"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-social fs-20" />
                      </span>
                      Social Profile
                    </Link>
                  </div>
                  <div
                    className="accordion-collapse collapse"
                    id="social"
                    data-bs-parent="#main_accordion"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Facebook</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook"
                              value={editingLead?.facebook || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.facebook && <small className="text-danger">{errorsEditForm.facebook}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Skype</label>
                            <input
                              type="text"
                              className="form-control"
                              name="skype"
                              value={editingLead?.skype || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.skype && <small className="text-danger">{errorsEditForm.skype}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Linkedin</label>
                            <input
                              type="text"
                              className="form-control"
                              name="linkedin"
                              value={editingLead?.linkedin || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.linkedin && <small className="text-danger">{errorsEditForm.linkedin}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Twitter</label>
                            <input
                              type="text"
                              className="form-control"
                              name="twitter"
                              value={editingLead?.twitter || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.twitter && <small className="text-danger">{errorsEditForm.twitter}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3 mb-md-0">
                            <label className="col-form-label">Whatsapp</label>
                            <input
                              type="text"
                              className="form-control"
                              name="whatsapp"
                              value={editingLead?.whatsapp || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.whatsapp && <small className="text-danger">{errorsEditForm.whatsapp}</small>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="col-form-label">Instagram</label>
                            <input
                              type="text"
                              className="form-control"
                              name="instagram"
                              value={editingLead?.instagram || ""}
                              onChange={handleInputChange}
                            />
                            {errorsEditForm.instagram && <small className="text-danger">{errorsEditForm.instagram}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Social Profile */}
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                  onClick={handleClose3}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpdateLead}
                >
                  Edit
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        {/* /Edit Lead */}
        {/* Convert Lead Modal */}
        <Modal show={showConvertModal} onHide={() => setShowConvertModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Convert Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              <strong>Lead: </strong> {newLead.firstName} {newLead.lastName}
            </p>

            <Form>


              {/* Account Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Account</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Account"
                    name="accountType"
                    value="new"
                    checked={accountType === "new"}
                    onChange={() => {
                      setAccountType("new");
                      setAccountName(newLead.company);
                      setSelectedAccount(null);
                      setContactType("new");
                      setOpportunityType("new");
                      setSelectedSalutation(newLead.salutation);
                      setContactFirstName(newLead.firstName);
                      setContactLastName(newLead.lastName);
                      setOpportunityName(newLead.company);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Account"
                    name="accountType"
                    value="existing"
                    checked={accountType === "existing"}
                    onChange={() => {
                      setAccountType("existing");
                      setAccountName(newLead.company);
                      setSelectedAccount(null);
                    }}
                  />
                </div>

                {accountType === "new" && (
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="Enter Account Name"
                    value={accountName}
                    onChange={(e) => setAccountName(e.target.value)}
                    required
                  />
                )}

                {accountType === "existing" && (
                  <Select
                    options={accountOptions}
                    isSearchable
                    value={selectedAccount}
                    onChange={(option) => setSelectedAccount(option)}
                  />
                )}
              </Form.Group>

              {/* Contact Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Contact</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Contact"
                    name="contactType"
                    value="new"
                    checked={contactType === "new"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setContactType("new");
                      setSelectedSalutation(newLead.salutation);
                      setContactFirstName(newLead.firstName);
                      setContactLastName(newLead.lastName);
                      setSelectedContact(null);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Contact"
                    name="contactType"
                    value="existing"
                    checked={contactType === "existing"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setContactType("existing");
                      setContactFirstName("");
                      setContactLastName("");
                    }}
                  />
                </div>

                {contactType === "new" && (
                  <>
                    <Select
                      className="select2"
                      options={optionSalutation}
                      classNamePrefix="react-select"
                      value={optionSalutation.find(option => option.value === selectedSalutation) || null}
                      onChange={(selectedOption) => setSelectedSalutation(selectedOption?.value || null)}
                    />

                    <Form.Control
                      className="mt-2"
                      type="text"
                      placeholder="First Name"
                      value={contactFirstName}
                      onChange={(e) => setContactFirstName(e.target.value)}
                      required
                    />
                    <Form.Control
                      className="mt-2"
                      type="text"
                      placeholder="Last Name"
                      value={contactLastName}
                      onChange={(e) => setContactLastName(e.target.value)}
                      required
                    />
                  </>
                )}

                {contactType === "existing" && (
                  <Select
                    options={contactOptions}
                    isSearchable
                    value={selectedContact}
                    onChange={(option) => setSelectedContact(option)}
                  />
                )}
              </Form.Group>

              {/* Opportunity Selection */}
              <Form.Group className="mb-3">
                <Form.Label>Opportunity</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label="Create New Opportunity"
                    name="opportunityType"
                    value="new"
                    checked={opportunityType === "new"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setOpportunityType("new");
                      setOpportunityName(newLead.company);
                      setSelectedOpportunity(null);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Choose Existing Opportunity"
                    name="opportunityType"
                    value="existing"
                    checked={opportunityType === "existing"}
                    disabled={accountType === "new"}
                    onChange={() => {
                      setOpportunityType("existing");
                      setOpportunityName(newLead.company);
                    }}
                  />
                </div>

                {opportunityType === "new" && (
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="Enter Opportunity Name"
                    value={opportunityName}
                    onChange={(e) => setOpportunityName(e.target.value)}
                    required
                  />
                )}

                {opportunityType === "existing" && (
                  <Select
                    options={opportunityOptions}
                    isSearchable
                    value={selectedOpportunity}
                    onChange={(option) => setSelectedOpportunity(option)}
                  />
                )}
              </Form.Group>

              {/* Converted Status */}
              <Form.Group className="mb-3">
                <Form.Label>Converted Status</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={
                    statusOptions.find((status) => status.id === editingLead?.statusDto?.statusId)?.name ||
                    "No Status"
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConvertLead}>Convert</Button>
          </Modal.Footer>
        </Modal>
        <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />

        {/* /Convert Lead Modal */}

        {/* Delete Lead */}
        <div className="modal fade" id="delete_lead" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Lead?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br />
                    lead <strong>{leadToDelete?.name}</strong>?
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                      onClick={handleConfirmDelete}
                    >
                      Yes, Delete {leadToDelete?.name}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
        {/* Create Lead */}
        <Modal show={openModal} onHide={() => setOpenModal(false)}>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-chart-arcs" />
              </div>
              <h3>Leads Created Successfully!!!</h3>
              <div className="col-lg-12 text-center modal-btn">
                <button
                  onClick={() => {
                    setOpenModal(false);
                    window.location.reload();
                  }}
                  className="btn btn-outline-secondary"
                >
                  Cancel
                </button>
                <Link
                  to={`/leads-details/${createdLeadUuid}`}
                  onClick={() => {
                    setOpenModal(false);

                  }}
                  className="btn btn-primary"
                >
                  Ok
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Lead */}
        {/* Edit Lead Success Modal */}
        <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-chart-arcs" />
              </div>
              <h3>Leads Edited Successfully!!!</h3>
              <div className="col-lg-12 text-center modal-btn">
                <button
                  onClick={() => {
                    setOpenEditSuccessModal(false);
                    window.location.reload();
                  }}
                  className="btn btn-outline-secondary"
                >
                  Cancel
                </button>
                <Link
                  to={`/leads-details/${editedLeadUuid}`}
                  onClick={() => {
                    setOpenEditSuccessModal(false);
                  }}
                  className="btn btn-primary"
                >
                  Ok
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Edit Lead Success Modal */}
        {/* Tag Modal */}
        {showAssignTagModal && (
          <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Assign Tags to Leads</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowAssignTagModal(false)}
                    aria-label="Close"

                  ><i className="ti ti-x" /></button>
                </div>

                <div className="modal-body">
                  <Select
                    isMulti
                    options={tagOptions}
                    onChange={(selectedOptions) =>
                      setSelectedTagIds(selectedOptions ? selectedOptions.map((tag) => tag.value) : [])
                    }
                    placeholder="Select tags"
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setShowAssignTagModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAssignTag}
                  >
                    Assign
                  </button>
                </div>
                <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
              </div>
            </div>
          </div>
        )}
        {/* Add to Campaign Modal */}
        {showCampaignModal && (
          <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Leads to Campaign</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowCampaignModal(false)}
                    aria-label="Close"
                  ><i className="ti ti-x" /></button>
                </div>

                <div className="modal-body">
                  <Select
                    getOptionLabel={(campaign) => campaign.name}
                    getOptionValue={(campaign) => campaign.id.toString()}
                    options={campaignOptions}
                    onChange={(selectedOption) =>
                      setSelectedCampaign(selectedOption ? selectedOption.id : undefined)
                    }
                    value={campaignOptions.find((c) => c.id === selectedCampaign) || null}
                    placeholder="Select campaign"
                  />
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => setShowCampaignModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleAddCampaign}>Add</button>
                </div>
                <ResponseModal
                  show={showMessageModal}
                  onClose={() => setShowMessageModal(false)}
                  response={response}
                />
              </div>
            </div>
          </div>
        )}
        {/*Change Owner Modal */}
        {showChangeOwnerModal && (
          <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Change Owner</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowChangeOwnerModal(false)}
                    aria-label="Close"
                  ><i className="ti ti-x" /></button>
                </div>

                <div className="modal-body">
                  <Select
                    className="select2"
                    options={ownerOptions}
                    classNamePrefix="react-select"
                    value={ownerOptions.find((option) => option.value === selectedOwnerUuid) || null}
                    onChange={(selectedOption) => {
                      setSelectedOwnerUuid(selectedOption?.value);
                    }}
                    placeholder="Select Owner"
                  />
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => setShowChangeOwnerModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleChangeOwner}>Change</button>
                </div>
                <ResponseModal
                  show={showMessageModal}
                  onClose={() => setShowMessageModal(false)}
                  response={response}
                />
              </div>
            </div>
          </div>
        )}

        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        {/* Access */}
        <div className="modal fade" id="access_view" tabIndex={-1} aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Users</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    if (tempSelectedUsers.length === 0) {
                      setVisibility("public");
                      setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                    }
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {users.map(user => (
                  <div key={user.id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`user-${user.id}`}
                      checked={tempSelectedUsers.includes(user.id)}
                      onChange={(e) => {
                        setTempSelectedUsers(prev =>
                          e.target.checked ? [...prev, user.id] : prev.filter(id => id !== user.id)
                        );
                      }}
                    />
                    <label className="form-check-label" htmlFor={`user-${user.id}`}>
                      {user.username}
                    </label>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    if (tempSelectedUsers.length === 0) {
                      setVisibility("public");
                      setNewLead(prev => ({ ...prev, public: true, selectedPeople: [] }));
                    } else {
                      setNewLead(prev => ({ ...prev, selectedPeople: tempSelectedUsers }));
                    }
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* /Access */}

        {/* Import CSV Modal */}
        <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Import Leads from CSV</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Select CSV File</label>
              <input
                type="file"
                className="form-control"
                accept=".csv"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setCsvFile(file);
                  }
                }}
              />
              <div className="form-text">
                Please make sure your CSV file follows the required format.
                <Button
                  variant="link"
                  className="p-0 ms-1"
                  onClick={handleDownloadSample}
                >
                  Download template
                </Button>
              </div>
            </div>
            {importErrors.length > 0 && (
              <div className="alert alert-danger">
                <h6 className="alert-heading">Import Errors:</h6>
                <ul className="mb-0">
                  {importErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={() => setShowImportModal(false)}>Cancel</Button>
            <Button
              variant="primary"
              onClick={handleImportCsv}
              disabled={!csvFile}
            >
              Import
            </Button>
          </Modal.Footer>
        </Modal>
        <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />

        {/* Import Result Modal */}
        <Modal show={showResultModal} onHide={() => setShowResultModal(false)}>
          <Modal.Body>
            <div className="text-center">
              <div className="avatar avatar-xl bg-success-light rounded-circle mb-3">
                <i className="ti ti-check fs-36 text-success" />
              </div>
              <h4 className="mb-2">Import Result</h4>
              <p className="mb-0">
                {importMessage}
              </p>
              {importErrors.length > 0 && (
                <div className="alert alert-danger mt-3">
                  <h6 className="alert-heading">Import Errors:</h6>
                  <ul className="mb-0">
                    {importErrors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="d-flex align-items-center justify-content-center mt-4">
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowResultModal(false);
                    setImportMessage('');
                    setImportErrors([]);
                    setCsvFile(null);
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* Access Modal */}
        <Modal show={showModalAccess} onHide={handleCloseModalAccess} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Set Accessibility</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Radio buttons */}
              <Form.Check
                type="radio"
                label="Public"
                value="public"
                name="access"
                checked={accessType === "public"}
                onChange={handleRadioChange}
              />
              <Form.Check
                type="radio"
                label="Private"
                value="private"
                name="access"
                checked={accessType === "private"}
                onChange={handleRadioChange}
              />
              <Form.Check
                type="radio"
                label="Selected People"
                value="isSelected"
                name="access"
                checked={accessType === "isSelected"}
                onChange={() => {
                  setAccessType("isSelected");
                  setTempSelectedUsers(selectedPeople);
                }}
              />

              {accessType === "isSelected" && (
                <>
                  <div className="mb-3 mt-3">
                    <label className="col-form-label">Select Users</label>
                    <Select
                      isMulti
                      name="users"
                      options={users.map(user => ({
                        value: user.id,
                        label: `${user.username} - ${user.role}`
                      }))}
                      value={users
                        .filter(user => tempSelectedUsers.includes(user.id))
                        .map(user => ({
                          value: user.id,
                          label: `${user.username} - ${user.role}`
                        }))}
                      onChange={(selectedOptions) => {
                        setTempSelectedUsers(selectedOptions.map(opt => opt.value));
                      }}
                      isSearchable={true}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          maxWidth: '100%',
                          overflow: 'hidden'
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          whiteSpace: 'nowrap'
                        }),
                        multiValueLabel: (provided) => ({
                          ...provided,
                          maxWidth: '200px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        })
                      }}
                    />
                  </div>

                  {tempSelectedUsers.length > 0 && (
                    <div className="mt-2 p-2 border rounded bg-light">
                      <strong>Selected Users:</strong>
                      <ul className="mb-0 ps-3">
                        {tempSelectedUsers.map(userId => {
                          const user = users.find(u => u.id === userId);
                          return user ? (
                            <li key={user.id}>
                              {user.username} - {user.role}
                            </li>
                          ) : null;
                        })}
                      </ul>
                    </div>
                  )}
                </>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModalAccess}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              setSelectedPeople(tempSelectedUsers);
              handleSaveAccessibility();
            }}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>


        <ResponseModal
          show={showMessageModal}
          onClose={() => setShowMessageModal(false)}
          response={response}
        />

      </>
    </>
  );
};
export default Leads;